// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;
module.exports.WiMoonAltWaningCrescent6 = function WiMoonAltWaningCrescent6(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "version": "1.1",
      "id": "Layer_1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 30 30",
      "style": "enable-background:new 0 0 30 30;"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M3.74,14.44c0-1.52,0.3-2.98,0.89-4.37s1.4-2.58,2.4-3.59s2.2-1.81,3.59-2.4s2.84-0.89,4.37-0.89s2.98,0.3,4.37,0.89\n\ts2.59,1.4,3.6,2.4s1.81,2.2,2.4,3.59s0.89,2.84,0.89,4.37s-0.3,2.98-0.89,4.37s-1.4,2.59-2.4,3.6s-2.2,1.81-3.6,2.4\n\ts-2.85,0.89-4.37,0.89s-2.98-0.3-4.37-0.89s-2.58-1.4-3.59-2.4s-1.81-2.2-2.4-3.6S3.74,15.97,3.74,14.44z M4.94,14.44\n\tc0,2.48,0.8,4.66,2.41,6.53s3.62,3.01,6.03,3.41c-1.01-0.5-1.86-1.1-2.56-1.82s-1.25-1.5-1.63-2.37s-0.66-1.77-0.83-2.7\n\ts-0.26-1.95-0.26-3.06c0-2.11,0.5-4.06,1.49-5.84s2.37-3.16,4.12-4.12c-1.63,0.21-3.11,0.77-4.45,1.7S6.87,8.3,6.1,9.76\n\tS4.94,12.77,4.94,14.44z"
      }
    }]
  })(props);
};